module.exports = __webpack_public_path__ + "static/media/parking1.f5272424.png";